var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceLocalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg6098",
    viewBox: "0 0 20 20",
    height: 27,
    width: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6102"
  })), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    style: {
      fill: "#061e37",
      strokeWidth: 0.79661018
    },
    id: "path6096",
    d: "m 11.066256,10.828968 v 6.952233 H 18.01849 V 10.828968 Z M 10.197227,9.5254239 h 8.690293 c 0.239976,0 0.434514,0.1945387 0.434514,0.4345146 v 8.6902925 c 0,0.239976 -0.194538,0.434514 -0.434514,0.434514 h -8.690293 c -0.2399763,0 -0.4345151,-0.194538 -0.4345151,-0.434514 V 9.9599385 c 0,-0.2399759 0.1945388,-0.4345146 0.4345151,-0.4345146 z m 5.938014,4.7866131 c 0.08354,0.04635 0.131103,0.118187 0.142705,0.215519 0.0116,0.09733 -0.01741,0.180758 -0.08702,0.250281 l -2.178851,2.05786 c -0.05105,0.05098 -0.116019,0.07648 -0.194913,0.07648 -0.102098,0 -0.182151,-0.04403 -0.240161,-0.132093 -0.05801,-0.08806 -0.06845,-0.178439 -0.03133,-0.271137 l 0.626512,-1.501687 -1.225168,-0.709127 c -0.07889,-0.04635 -0.125302,-0.118188 -0.139224,-0.21552 -0.01392,-0.09733 0.01392,-0.180758 0.08353,-0.25028 l 2.178851,-2.057861 c 0.06033,-0.05098 0.125301,-0.07647 0.194914,-0.07647 0.07889,0 0.147344,0.02896 0.205354,0.0869 0.05801,0.05794 0.08701,0.126298 0.08701,0.20509 0,0.04635 -0.0093,0.08806 -0.02784,0.125141 l -0.619545,1.487777 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLocalIcon);
export default __webpack_public_path__ + "static/media/device-local-icon.a7e5c60d125b5e2c6c7de02357cb2c96.svg";
export { ForwardRef as ReactComponent };